/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Response for API key creation with private key.
 */
export interface LakeApiKeyCreationResponse {
  id?: number;
  active?: boolean;
  name?: string;
  accountId?: number;
  publicKey?: string;
  permission?: LakeApiKeyCreationResponse.PermissionEnum;
  cidr?: string;
  privateKey?: string;
}
export namespace LakeApiKeyCreationResponse {
  export const PermissionEnum = {
    Create: 'CREATE',
    Read: 'READ',
  } as const;
  export type PermissionEnum = (typeof PermissionEnum)[keyof typeof PermissionEnum];
}
